import { Breadcrumbs } from '@mui/material'
import React,{ useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import Education from './Education'
import axios from 'axios'
import { BASE_URL } from '../../../constants'


function EducationList() {
  const [eduLists, setEduLists] = useState([]);

  useEffect(()=>{
  
      axios.get(`${BASE_URL}/programs/education`, { 
        headers: {
          "authorization": `${localStorage.getItem('token')}` ,
          "Content-Type": "application/json",
        }}).then((res) => {
          setEduLists(res.data)
    })
   
  },[])

  return (
    <div className='full-container'>
        <div style={{margin:'0px 10px'}}>
            <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" to="/programs" >
                Program
            </Link>
            <Typography  color="text.primary">Education</Typography>
            </Breadcrumbs>
        </div>
        <div style={{minHeight:420}}>
        {
          eduLists && eduLists.length > 0 && eduLists.map((edu, index)=>{
            return <Education key={index} edu={edu} />
          })
        }

        {
          eduLists && eduLists.length <=0 &&  <div style={{
                display:'flex', 
                backgroundColor:'#def1fc', 
                border:'solid 1px #ccc',
                margin:'10px 0px'
             }}
             >
              <div style={{width: '20%', display:'flex', padding: '5px', flexDirection:'column', alignItems:'center'}}>
                  <Typography sx={{fontSize:'16px'}} > No education to display. </Typography>
              </div>
            </div>
        }
            
       </div>
    </div>
  )
}

export default EducationList